<div class="page-title-area item-bg2">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a href="/" i18n>Home</a></li>
                <li i18n>Article Details</li>
                <li></li>
            </ul>
            <h2 i18n>Article Details</h2>
        </div>
    </div>
</div>

<div class="blog-details-area ptb-100" [class.dark-blog-details-area]="themeService.isDark()">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12">
                <div class="blog-details-desc">
                    <div class="article-content">

                        <div class="entry-meta">
                            <ul>
                                <li>
                                    <i class='bx bx-folder-open'></i>
                                    <span i18n>CATEGORY</span>
                                    <a >{{article?.type.type_name}}</a>
                                </li>
                                <li>
                                    <i class='bx bx-group'></i>
                                    <span i18n>AUTHOR</span>
                                    <a>{{article?.author}}</a>
                                </li>
                                <li>
                                    <i class='bx bx-calendar'></i>
                                    <span i18n>PUBLISHED DATE</span>
                                    <a>{{article?.created_at|date:'longDate'}}</a>
                                </li>
                                <li *ngIf="article?.article">
                                    <a [href]="imageURL+ article?.article" target="_blank">
                                        <i class='bx bx-download bx-tada bx-rotate-180' style='color:#151e3f; top:0%;' ></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <h3>{{article?.title}}</h3>

                        <h3 *ngIf="article?.abstract" i18n>Abstract</h3>
                        <p>{{article?.abstract}}</p>

                        <blockquote class="wp-block-quote" *ngIf="article?.keywords">
                            <h3 i18n>Keywords</h3>
                            <p>
                                {{article?.keywords}}
                            </p>
                        </blockquote>
                        
                        <h3 i18n *ngIf="article?.text">Article</h3>
                        <p> {{article?.text}}</p>
                        


                        <ul class="wp-block-gallery columns-3">
                            <li class="blocks-gallery-item" *ngFor="let img of article?.article_images">
                                <figure>
                                    <img [src]="imageURL+img.image_url" style="max-height:25em" alt="image">
                                </figure>
                            </li>
                           

                        </ul>


                    </div>

                </div>

            </div>
        </div>
    </div>